import { createApi } from '@reduxjs/toolkit/query/react'

import {
  AssignEjecutivoOperativoPayload,
  AssignEjecutivoOperativoResponse,
  EjecutivoOperativoResponse,
} from '../interfaces/EjecutivoOperativo'

import { baseQuery } from '@/core/api/baseQuery'
import { GenericResponseOData } from '@/core/api/interfaces/GenericResponseOData'

export const agenteOperativoApi = createApi({
  reducerPath: 'agenteOperativoApi',
  baseQuery,
  endpoints: (builder) => ({
    getEjecutivosOperativos: builder.query<
      GenericResponseOData<EjecutivoOperativoResponse[]>,
      void
    >({
      query: () => ({
        url: `/AgenteOperativos?$filter=Activo eq true`,
        method: 'GET',
      }),
    }),
    assignAgenteOperativo: builder.mutation<
      AssignEjecutivoOperativoResponse,
      AssignEjecutivoOperativoPayload
    >({
      query: (values) => ({
        url: `/AsignacionAgenteOperativoBusiness`,
        method: 'PUT',
        body: values,
      }),
    }),
  }),
})

export const {
  useLazyGetEjecutivosOperativosQuery,
  useAssignAgenteOperativoMutation,
} = agenteOperativoApi
